import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageLogService } from 'app/pechkin/messagelog/services/message-log.service';
import { MessageLog } from 'app/pechkin/messagelog/services/messageLog';

@Component({
  templateUrl: './message-log-view.component.html',
})
export class MessageLogViewComponent implements OnInit {
  public messageLog: MessageLog;

  constructor(private messageLogService: MessageLogService, private route: ActivatedRoute, private router: Router) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    this.loadLog(id);
  }

  loadLog(id: string): void {
    this.messageLogService.getMessageLog(id).subscribe((resp) => (this.messageLog = resp));
  }

  public goToList() {
    this.router.navigate(['/messagelogs/']);
  }
}
